import styled from 'styled-components';

export const Container = styled.div`

    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    -webkit-tap-highlight-color: transparent;

    p {
        margin: 0
    }

    .div-pai {
        margin: 32px;
        background-color: #fff;
        max-width: 1096px;
        min-width: 300px;
        width: 88%;
        border-radius: 8px;

        @media (max-width: 1330px) {
            margin-bottom: 80px;
        }

        @media (max-width: 690px) {
            margin-top: 161px;
        }

        @media(max-width: 360px) {
            margin: 24px;
            margin-top: 153px;
            margin-bottom: 80px;
        }

        .div-rota {
            margin-right: 16px;
            margin-top: 40px;
            margin-left: 32px;
            width: 90%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis;

            @media(max-width: 360px) {
                margin-left: 16px
            }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }
        }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-left: 32px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 0;
            margin-left: 32px;
            margin-right: 16px;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                margin-left: 16px;
                font-size: 24px;
            }
        }

        h5 {
            margin-top: 24px;
            margin-left: 32px;
            margin-right: 56px;
            margin-bottom: 40px;           
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 360px) {
                margin-left: 16px;
                margin-bottom: 24px;   
            }
        }

        h4 {
            margin-top: 64px;
            margin-bottom: 40px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                margin-left: 16px;
                margin-top: 68px;
                margin-bottom: 36px;
            }
        }

        .pages {
            width: 100%;
            padding-left: 8px;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 56px;

            .page {
                background-color: #fff;
                margin-left: 24px;
                margin-top: 24px;
                cursor: pointer;
                width: 100%;
                max-width: 382px;
                border-radius: 8px;
                border: 1.5px solid #dedede;

                @media (max-width: 510px) {
                    width: 80%;
                }

                @media (max-width: 360px) {
                    margin-left: 8px;
                    margin-top: 16px;
                    width: 89%;
                }

                .emoji {
                    margin-top: 32px;
                    margin-left: 32px;

                    @media(max-width: 360px) {
                            margin-left: 16px;
                        }
                }

                .botao {
                    display: flex;
                    width: 100%;
                    padding-left: 32px;
                    margin-bottom: 32px;

                    @media(max-width: 510px) {
                        padding-left: 0px;
                        align-items: center;
                        justify-content: center;
                    }

                    .salvar {
                        cursor: pointer;
                        height: 40px;
                        width: 92px;
                        background-color: #fff;
                        outline: none;
                        border: none;
                        border-radius: 20px;
                        justify-content: center;
                        align-items: center;
                        color: #c42027;
                        border: 1.5px solid #c42027;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 600;
                        transition: 0.2s;

                        :hover {
                            background-color: #9c1a1f
                        }

                        :active {
                            background-color: #d7232c
                        }

                        @media(max-width: 510px) {
                            width: 83%;
                        }

                        @media(max-width: 360px) {
                            width: 90%;
                            height: 32px;
                        }
                    }
                    
                    .salvar1 {
                        outline: none; 
                        border: none;
                        justify-content: center;
                        align-items: center;
                        color: #c42027;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 600;
                        text-decoration: none;
                        transition: 0.2s;
            
                    :hover {
                        background-color: #9c1a1f;
                    }
            
                    :active {
                        background-color: #d7232c
                    }
            
                    @media(max-width: 510px) {
                        width: 83%;
                    }

                    @media(max-width: 360px) {
                        width: 90%;
                        height: 32px;
                    }
                }
            }

                :hover {
                    border: 1.5px solid #a49a9b;
                    -webkit-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
                    -moz-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
                    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);

                    .salvar {
                        background-color: #c32027;
                        color: #fff;
                    }

                    .salvar1 {
                        color: #fff;
                    }
                }

                h4 {
                    margin: 0;
                    padding-left: 32px;
                    padding-bottom: 16px;

                    @media (max-width: 360px) {
                        padding-left: 16px;
                    }
                }

                h5 {
                    font-size: 12px;
                    margin: 0;
                    line-height: 1.5;
                    padding-left: 32px;
                    padding-right: 16px;
                    padding-bottom: 16px;

                    @media (max-width: 360px) {
                        padding-left: 16px;
                    }
                }
            }
        }
    }

    
`